const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#1A362D" />
    <path d="M10 42 L25 18 L33 30 L40 21 L54 42 Z" fill="#FAFAFA" />
    <path d="M11 50 Q22 45.5 32 50 T53 50" stroke="#A87B51" strokeWidth="3.5" fill="none" strokeLinecap="round" />
  </svg>
);

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      <span className="leading-none">
        <span className={`font-serif text-2xl font-semibold tracking-tight ${light ? "text-paper" : "text-pine"}`}>
          Rest'Ô Bréda
        </span>
        <span className={`mt-1 block text-[10px] font-semibold uppercase tracking-[0.32em] ${light ? "text-paper/60" : "text-pine/60"}`}>
          Le Haut-Bréda
        </span>
      </span>
    </span>
  );
}
